import React from 'react';
import { SectionTitle } from '../common';
import { useDirector } from '../../hooks/useDirector';

const DirectorSection: React.FC = () => {
  const { director } = useDirector();
  return (
    <section className="about-director-section py-5">
      <div className="container">
        <SectionTitle subtitle="[ DIRECTOR ]" title="" />
        <div className="row align-items-center g-4">
          <div className="col-lg-4 col-md-5">
            <p className="mb-2" style={{ color: '#0066CC', fontSize: '1.7rem', fontWeight: 600 }} />
            <h3 className="fw-bold mb-4" style={{ fontSize: '3rem', color: '#002D5C', letterSpacing: '2px' }}>
              JAC LEUNG
            </h3>
            <div style={{ position: 'relative', overflow: 'hidden' }}>
              <img
                src="/images/about/dr jac.png"
                alt="Dr. Jac Leung"
                className="w-100"
                style={{ objectFit: 'cover', background: 'transparent', display: 'block' }}
              />
            </div>
          </div>
          <div className="col-lg-8 col-md-7">
            <p style={{ color: '#273351', fontSize: '1.8rem', lineHeight: 1.8, margin: 0 }}>
              {director?.description || 'Loading...'}
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default DirectorSection;

